import { ListBooking } from 'types';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { formatMoney } from 'lib/formatters';
import { toDisplayDateFormat } from 'lib/utils';
import { Label } from '../Label';
import { Box } from '@qga/roo-ui/components';

interface DepositPayReminderProps {
  booking: ListBooking;
}

export const DepositPayReminder = ({ booking }: DepositPayReminderProps) => {
  const scheduledPayment = getPendingScheduledPayment(booking);

  if (scheduledPayment) {
    const labelText = `Final payment of ${formatMoney(scheduledPayment.total)} due before ${toDisplayDateFormat(
      scheduledPayment.deferredTo,
    )}`;

    return (
      <Box mt={6} minWidth="180px">
        <Label heading="Deposit Pay" message={labelText} iconName="depositPay" />
      </Box>
    );
  }

  return null;
};
